const m = require('minthril');
const { component } = require('../../component');
const { Breadcrumbs } = require('../../components/breadcrumbs');

const AuthPage = component(() => {
  return {
    view: ({ attrs: { onSignIn } }) => m('section.panel.auth-panel',
      m(Breadcrumbs, { items: [{ label: 'Sign in' }] }),
      m('h2', 'Spache app'),
      m('p', 'Sign in to manage your sites.'),
      m('button.button', { onclick: onSignIn }, 'Continue with Google'),
      m('p.auth-panel__terms', [
        'By continuing, you agree to the ',
        m('a', { href: '/terms' }, 'Spache Terms and Conditions'),
        '.'
      ])
    )
  };
});

module.exports = { AuthPage };
